import { useSuspenseQuery } from "@tanstack/react-query";
import { Api } from "../api.config";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsAdSets = (
	campaignId: string,
	from: string,
	to: string,
) => {
	const company = useCompany();
	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Reporting.CampaignAdSets(
			company.id,
			campaignId,
			from,
			to,
		),
		queryFn: () =>
			Api.GetMetaAdsCampaignAdSets(campaignId, from, to).then((r) => r.data),
	});
};
